import React from 'react'
import { Services } from '../../../services'
import { AuthContext } from '../../../contexts/AuthContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import RouterHook from '../../../contexts/RouterHook'
import { error404 } from '../../../assets/'
import { Box, Button, Typography } from '@mui/material'

import './styles404.css'

export default function CompError({ title, message }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)

  const serverRouter = RouterHook()

  return (
    <div className='contain-centraliza-error'>
      <div className='contain-error-404'>
        <Typography sx={{ typography: { xs: 'h5', md: 'h4' } }} color='primary.main' gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ typography: { xs: 'body1', md: 'body1' } }} align='center' gutterBottom>
          {message}
        </Typography>
        <img src={error404} alt='Erro 404' />
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <Button
            variant='contained'
            onClick={() => {
              if (sttAuthCtx.isLogged) {
                const label = Services.ReturnLabelURL(userUCtx.usuario.estado, userUCtx.usuario.cidade)

                serverRouter('home', label)
              } else serverRouter('login')
            }}
          >
            {sttAuthCtx.isLogged ? 'Voltar para tela inicial' : 'Ir para tela de Login'}
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              const newUrl = 'https://www.agendeiquadras.com.br/appAgendei/'
              window.open(newUrl)
            }}
          >
            Procurar sua cidade
          </Button>
        </Box>
      </div>
    </div>
  )
}
